import type { ReactElement } from 'react';

const DEFAULT_NOTICE =
  'Cambridge assessment fees are set and collected by Cambridge International directly. ' +
  'They are not included in the Learn Plus fee shown here.';

export function ExamFeeNotice({ text = DEFAULT_NOTICE }: { text?: string }): ReactElement {
  return (
    <aside className="notice" role="note" aria-label="Cambridge examination fee notice">
      <strong>Cambridge examination fees</strong>
      <p>{text}</p>
    </aside>
  );
}
